function defaultState() {
  return {
    breadcrumbs: [{
      name:'Dashboard',
      path:'/dashboard'
    }],
    intro: false,
    setting: {
      locale: 'en'
    }
  }
}

const state = defaultState();

const actions = {

  // イントロの表示済みフラグをセット
  setIntro ({commit}, intro) {
    commit('setIntro', intro)
  },

  // ヘッダーのパンくずリストをセット
  setBreadcrumbs ({commit}, breadcrumbs) {
    commit('setBreadcrumbs', breadcrumbs)
  },

  // ヘッダーのパンくずリストの末尾をセット
  setLastBreadcrumb ({commit}, lastBreadcrumb) {
    commit('setLastBreadcrumb', lastBreadcrumb)
  },

  // 言語設定をセット
  setLocaleSetting ({commit}, locale) {
    commit('setLocaleSetting', locale)
  },

  signOutReset({commit}) {
    commit('_reset');
  }
};

const mutations = {

  // イントロの表示済みフラグをセット
  setIntro (state, intro) {
    state.intro = intro
  },

  // ヘッダーのパンくずリストをセット
  setBreadcrumbs (state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },

  // ヘッダーのパンくずリストの末尾をセット
  setLastBreadcrumb (state, lastBreadcrumb) {
    state.breadcrumbs[state.breadcrumbs.length-1].name = lastBreadcrumb
  },

  // 言語設定をセット
  setLocaleSetting (state, locale) {
    state.setting.locale = locale
  },

  _reset(state) {
    const initialState = defaultState();
    for (const key in state) {
      if (key === 'intro' || key === 'setting') {
        continue;
      }
      if (state.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  }
};

export default {
  state,
  actions,
  mutations
}
